import {Component, Input} from '@angular/core';
import {NgClass} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-selection-actions-bar',
  imports: [
    NgClass,
    TranslatePipe
  ],
  templateUrl: './selection-actions-bar.component.html',
  styleUrl: './selection-actions-bar.component.scss'
})
export class SelectionActionsBarComponent {

  @Input() selectedCount: number = 0;
  @Input() selectionLabelKey: string = '';
  @Input() reserveSpaceWhenEmpty: boolean = false;
}
